import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminShell } from './components/admin/AdminShell';
import { PinGateBoundary } from './components/PinGateBoundary';
import { CommissionDataProvider } from './contexts/CommissionDataContext';
import { AdminOverview } from './pages/AdminOverview';
import { MyCommissions } from './pages/MyCommissions';
import { OfficerCommissions } from './pages/OfficerCommissions';
interface AppProps {
  /** Admin experience: company overview, people drill-down, recalculate, BPS overrides & adjustments. */
  isAdmin?: boolean;
  /** How the dashboard PIN gate behaves on load. */
  pinGate?: 'verify' | 'create' | 'off';
  /** Show the statement load-failure state (Try again recovers). */
  simulateLoadError?: boolean;
}
export function App({
  isAdmin = true,
  pinGate = 'verify',
  simulateLoadError = false
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="23w4ey1znd61d">
      <CommissionDataProvider data-id="element-1" data-mp="23ujho4ly78zt">
        <PinGateBoundary mode={pinGate} data-id="element-2" data-mp="23ti8k5ohswkq">
          <Routes data-id="element-3" data-mp="3ikqyfyb7r257">
            {isAdmin ? <Route element={<AdminShell data-id="element-5" data-mp="3ii4q3wgi0ilx" />} data-id="element-4" data-mp="3ihv2gfixenje">
                <Route path="/" element={<AdminOverview data-id="element-7" data-mp="3mk84asujy1aw" />} data-id="element-6" data-mp="3mkrdnl64zhdb" />
                <Route path="/people/:officerId" element={<OfficerCommissions simulateLoadError={simulateLoadError} data-id="element-9" data-mp="3rbznujfaj6rj" />} data-id="element-8" data-mp="3mj6jvxrnc2gi" />
                <Route path="/me" element={<MyCommissions isAdmin simulateLoadError={simulateLoadError} data-id="element-11" data-mp="4wxfu7a14id" />} data-id="element-10" data-mp="5os92t1uy7l" />
              </Route> : <Route path="/" element={<MyCommissions isAdmin={false} simulateLoadError={simulateLoadError} data-id="element-13" data-mp="2zng0qi58cgrv" />} data-id="element-12" data-mp="2zmo5x9jgin2n" />}
            <Route path="*" element={<Navigate to="/" replace data-id="element-15" data-mp="38l8hzruihyhw" />} data-id="element-14" data-mp="33oi1x4ipj2wh" />
          </Routes>
        </PinGateBoundary>
      </CommissionDataProvider>
    </BrowserRouter>;
}